import { createSlice } from '@reduxjs/toolkit'

export const marketListSlice = createSlice({
  name: 'marketList',
  initialState: {
    value: []
  },
  reducers: {
    setMarketsList: (state, payload) => {
      state.value = payload.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setMarketsList } = marketListSlice.actions

export default marketListSlice.reducer